/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import DOMPurify from 'dompurify';
import { Grid, Typography } from '@material-ui/core';
import { Trans } from 'react-i18next';
import Tooltip from '../../common/Tooltip';
import { uiSchemaProperties } from '../../../shared/enums/uiSchemaProperties';

const SubtitleField = ({ subtitle, schema, uiSchema }) => {
  const subtitleToDisplay = schema?.subtitle ? schema.subtitle : subtitle;
  const tooltip = schema?.config?.tooltip ?? uiSchema?.[uiSchemaProperties.UI_TOOLTIP];
  const variant = uiSchema?.[uiSchemaProperties.UI_VARIANT_TITLE] || 'h4';

  if (subtitleToDisplay) {
    return (
      <>
        <Grid container direction="row" alignItems="center">
          <Typography
            variant={variant}
            component="h3"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(subtitleToDisplay),
            }}
          />
          {tooltip && <Tooltip title={<Trans i18nKey={tooltip} />} />}
        </Grid>
      </>
    );
  }
  return null;
};

export default SubtitleField;
